import { createSlice } from "@reduxjs/toolkit";

const languageSlice=createSlice({
    name:"language",
    initialState:{
        languageDefault:"en"
    },
    reducers:{
        changeLang:(state,action)=>{
            state.languageDefault=action.payload
        }
    }
})
export const {changeLang}=languageSlice.actions
export default languageSlice.reducer